import React from 'react';
import { getCookies } from 'cookies-next';
import { useRouter } from 'next/router';
import {
  IllustrationHeader,
  IllustrationNotice,
  IllustrationErrorDetails,
  IllustrationContent,
  getIllustrationFromType,
  IllustrationErrorTypes as ErrorTypes,
  TemplateActions as Actions
} from '@cvent/carina/components/Templates';
import { ActionType } from '@cvent/carina/components/Templates/utils/helpers';
import { useTranslate } from 'nucleus-text';

import { ErrorInstance } from '@components/providers/ErrorProvider';

export type ErrorProps = {
  errorType?: keyof typeof ErrorTypes;
  errorDetail?: ErrorInstance;
};

const TEST_ID = 'error';
export const Error = ({
  errorType = 'FATAL_ERROR',
  errorDetail = { contentKey: 'hardError_bodyMsg__resx', props: null }
}: ErrorProps): JSX.Element => {
  const { translate } = useTranslate();
  const router = useRouter();
  const cookies = getCookies();

  const {
    httpLogRequestId = cookies.LoginRequestId,
    httpLogPageLoadId,
    date = new Date().toUTCString()
  } = router.query;

  const actions: ActionType[] = [
    {
      value: translate('error_go_back'),
      onClick: (): void => router.back()
    }
  ];

  const content = errorDetail.props
    ? translate(errorDetail.contentKey, errorDetail.props)
    : translate(errorDetail.contentKey);

  return (
    <IllustrationNotice
      aria-label={translate('error_title')}
      title={translate('error_title')}
      testID={`${TEST_ID}_notice`}
      illustration={getIllustrationFromType(ErrorTypes[errorType])}
    >
      <IllustrationHeader testID={`${TEST_ID}_header`}>{translate('error_title')}</IllustrationHeader>
      <IllustrationContent testID={`${TEST_ID}_content`}>{content}</IllustrationContent>
      <Actions testID={`${TEST_ID}_actions`} actions={actions} position="center" />
      <IllustrationErrorDetails
        testID={`${TEST_ID}_details`}
        heading={translate('error_heading')}
        dateHeading={translate('error_date_heading')}
        instanceID={(httpLogRequestId || httpLogPageLoadId) as string}
        date={date as string}
      />
    </IllustrationNotice>
  );
};

export default Error;
